import React, { Component, useState, useEffect } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";

import ProfileUISchemaResolver from "./UISchemas/resolver";
import { FaFilter } from "react-icons/fa";
import ProfilesFilter from "./ViewEntityModal/ProfilesFilter/index";
import ProfileTableColumnResolver from "./Table/Columns/resolver";
import ProfileTableNoDataResolver from "./Table/NoDataView/resolver";
import getForeignWorkerDataSearch from "./ViewEntityModal/ProfilesFilter/search_queries";
import { RefineSearch } from "./../../global/css/component/Table";
import {
  parseObjectForGraphql,
  parseMultiSelectCheckboxForGQL,
} from "./helper";
import GQLUtil from "../../global/utils/gqlHelper";
import "./ViewEntityModal/ProfilesFilter/CaseFilter.scss";
import "./ProfilesDetail.scss";
import NewEntityModal from "./NewEntityModal";
import util from "../Utils/mappers";
import { ReactTable } from "../SimpleForm/ReactTable";

function ProfilesDetail(props) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [entityKey, setEntityKey] = useState(1);
  const [counties, setCounties] = useState(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const values = useSelector((state) => state.form.employer);
  const formData = useSelector((state) => state.form);
  const userProfile = useSelector((state) => state.appReducer.userDataReducer.data);
  console.log(userProfile);

  const openModal = () => {
    return true;
  };

  const closeModal = () => {
    return false;
  };

  //Toggles search Modal
  const toggleModal = () => {
    setIsOpen(!isOpen);
    return null;
  };

  //Search based of search term in ProfilesFilter component
  const searchResults = async (searchString, profileType) => {
    if (profileType === "foreign-worker") {
      const searchData = await getForeignWorkerDataSearch(
        searchString.search,
        userProfile.Group.id
      );
      setData(searchData);
      setLoading(false);
    }
    return null;
  };
  //Clearing Search in ProfilesFilter component
  const clearFilter = (profileType) => {
    if (profileType === "foreignWorker") {
      getForeignWorkerData();
    }
    return null;
  };

  const getEmpoloyeePOC = async (id) => {
    let query = `query {
    getPOCByEmployerId (employer_id:"${id}",group_id:"${userProfile.Group.id}" ) {
    id,
    POCFormData {
        poc_emp_profile_name,
        poc_emp_last_name,
        poc_emp_first_name
    }
    }
}

 `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data && data.data && data.data.getPOCByEmployerId) {
      setData(data.data.getPOCByEmployerId);
      setLoading(false);
    }
    return query;
  };

  const getAgents = async (id) => {
    let query = `query {
        getAgentsByAgentProfileId (agent_id:"${id}",group_id:"${userProfile.Group.id}" ) {
    id,
    AgentFormData {
        new_profile_individual_agent_last_name,
            new_profile_individual_agent_first_name,
            new_profile_individual_agent_profile_name,
            new_profile_individual_agent_job_title,
            new_profile_individual_agent_type_id
          }
    }
}

 `;

    const data = await GQLUtil.genericGQLQuery(query);
    if (data && data.data && data.data.getAgentsByAgentProfileId) {
      setData(data.data.getAgentsByAgentProfileId);
      setLoading(false);
    }
    return query;
  };

  const getRecruiterData = async (id) => {
    let query = `query {
        getRecruiterByGroupId (group_id:"${userProfile.Group.id}" ) {
    id,
    RecruiterFormData {
        new_profile_fl_recr_first_name,
            new_profile_fl_recr_last_name,
              new_profile_fl_recr_employer_name,
              new_profile_fl_recr_profile_name,
              new_profile_fl_recr_country_id,

            }
    }
}

 `;

    const data = await GQLUtil.genericGQLQuery(query);

    if (data && data.data && data.data.getRecruiterByGroupId) {
      setData(data.data.getRecruiterByGroupId);
      setLoading(false);
    }
  };

  const getAgentAttorneyData = async () => {
    const query = `
    query {
        getAgentProfileByGroupId(group_id:"${userProfile.Group.id}") {
        id,numberOfAgents
        AgentProfileFormData {
            new_profile_atty_agent_fein,
          new_profile_atty_agent_profile_name
          new_profile_atty_agent_dba
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getAgentProfileByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  const getCropData = async () => {
    const query = `
    query {
        getCropByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        CropFormData {
            new_profile_crop_crop_id
            new_profile_crop_crop_work_state
            new_profile_crop_crop_agricultural_activity
            new_profile_crop_per
            new_profile_crop_wage_offer
            new_profile_crop_piece_rate_offer
            new_profile_crop_piece_rate_units
            new_profile_crop_profile_name
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getCropByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  const getAgricultureData = async () => {
    const query = `
    query {
        getAgricultureByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        AgricultureFormData {
            new_profile_agriculture_emp_name
            new_profile_agriculture_worksite_address
            new_profile_agriculture_city
            new_profile_agriculture_state
            new_profile_agriculture_county{
              value,
              label
            }
            new_profile_agriculture_zip
            new_profile_agriculture_add_emp_info
            new_profile_agriculture_profile_name
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getAgricultureByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  const getWorkerHousingData = async () => {
    const query = `
    query {
        getWorkerHousingByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        WorkerHousingFormData {
      new_profile_worker_housing_type_of_housing,
      new_profile_worker_housing_physical_location_address,
      new_profile_worker_housing_physical_location_city,
      new_profile_worker_housing_physical_location_state,
      new_profile_worker_housing_physical_location_county{
        value,
        label
      },
      new_profile_worker_housing_physical_location_zip_code,
      new_profile_worker_housing_additional_housing_information,
      new_profile_worker_housing_total_units,
      new_profile_worker_housing_total_occupancy,
      new_profile_worker_housing_applicable_housing_standards {
        label,
        value
      },
      new_profile_worker_housing_applicable_housing_standards_local,
      new_profile_worker_housing_applicable_housing_standards_swa,
      new_profile_worker_housing_applicable_housing_standards_other_state,
      new_profile_worker_housing_applicable_housing_standards_other,
      new_profile_worker_housing_applicable_housing_standards_federal,
      new_profile_worker_housing_applicable_housing_standards_other_text,
      new_profile_worker_housing_profile_name
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getWorkerHousingByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  const getMaterialTermsData = async () => {
    const query = `
    query {
      getMaterialTermsByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        MaterialTermsFormData {
        new_profile_material_terms_section_number,
        new_profile_material_terms_summary,
        new_profile_material_terms_details,
        new_profile_material_terms_profile_name
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getMaterialTermsByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };
  const getForeignWorkerData = async () => {
    const query = `
    query {
        getForeignWorkerByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        ForeignWorkerFormData {
          new_profile_fw_profile_name,
          new_profile_fw_first,
          new_profile_fw_last,
          new_profile_fw_alien_reg_number,
          new_profile_fw_dob,
          new_profile_fw_birth_country,
          new_profile_fw_middle,
          new_profile_fw_address,
          new_profile_fw_address2,
          new_profile_fw_city,
          new_profile_fw_state,
          new_profile_fw_postal_code,
          new_profile_fw_country,
          new_profile_fw_province,
          new_profile_fw_class,
          new_profile_fw_citizen_country,
          new_group_fw_groups,
          new_profile_fw_education{
            appAEduTypeId,
            appAEduOther,
            appAEduMajors,
            appAEduInstName,
            appAEduCountryId,
            appAEduMonthYearAttained,
          },
          new_profile_fw_training_qualifications{
             appATrainingInstName,
             appATrainingName,
             appATrainingCert,
             appATrainingStartDate,
             appATrainingEndDate,
             appATrainingYearAwd,
          },
          new_profile_fw_skills{
            appASkillsInstName,
            appASkillsCountryId,
            appASkillsStateId,
            fwTerritory,
            appASkillsSpecial,
          },
          new_profile_fw_work_experience{
            appAExpEmpName, 
            appAExpAddress1,
            appAExpAddress2,
            appAExpCity,
            appAExpPostalCode,
            appAExpCountryId,
            appAExpStateTerritory,
            appAExpProvince,
            appAExpJobTitle,
            appAExpStartDate,
            appAExpEndDate,
            appAExpFWPresent,
            appAExpWorkHour,
            appAExpJobDuties,
          }
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getForeignWorkerByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  const getForeignWorkerGroupData = async () => {
    const query = `
    query {
      getForeignWorkerGroupByGroupId(group_id:"${userProfile.Group.id}") {
        id,
        ForeignWorkerGroupFormData {
        new_group_fw_group_name,
        new_group_fw_profiles,
        new_group_fw_num_profiles,
        }
        }
        }
        `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      setData(data.data.getForeignWorkerGroupByGroupId);
      setLoading(false);
    }

    if (data.data) {
      closeModal();
    }
  };

  useEffect(() => {
    const getCounties =  async () => {
    util
        .getCounties()
        .then((data) => setCounties(data))
        .catch((e) => {
          console.log(`unable to fetch counties`);
        });
    }
   getCounties();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      // let userInGroup = props.userProfile.Group && props.userProfile.Group.id;

      // if(userInGroup){
      let query;
      const uiSchema = ProfileUISchemaResolver(props.type); // where "type" === tableName
      const { view } = uiSchema;
      if (props.type === "agent-attorney") {
        getAgentAttorneyData();
      } else if (props.type === "agent-attorney-individs") {
        getAgents(props.id);
      } else if (props.type === "foreign-labor") {
        getRecruiterData();
      } else if (props.type === "crop") {
        getCropData();
      } else if (props.type === "agriculture") {
        getAgricultureData();
      } else if (props.type === "worker-housing") {
        getWorkerHousingData();
      } else if (props.type === "material-terms") {
        getMaterialTermsData();
      } else if (props.type === "foreign-worker") {
        getForeignWorkerData();
      } else if (view !== "main") {
        let id = props.id;
        getEmpoloyeePOC(id);
      } else if (props.type === "foreign-worker-group") {
        getForeignWorkerGroupData();
      } else {
        query = `
            query {
                getEmployerByGroupId(group_id:"${userProfile.Group.id}",) {
            id,numberOfPOC
                EmployerFormData {
                    new_profile_emp_legal_name,
                    new_profile_emp_profile_name,
                  new_profile_emp_fein
                }
            }
            }
            `;

        const data = await GQLUtil.genericGQLQuery(query);

        if (data && data.data && data.data.getEmployerByGroupId) {
          setData(data.data.getEmployerByGroupId);
          setLoading(false);
        }
      }

      // }
    };
    fetchData();
  }, [userProfile, props.type, props.id]);

  const handleGraphqlQuery = async (EmployerFormData, EmployerInput, returnField) => {
    let EFormData = parseObjectForGraphql(EmployerFormData);
    let EInput = parseObjectForGraphql(EmployerInput);
    const listOfEntities = {
      employer: {
        name: "Employer",
        returnFields: `id, EmployerFormData {
                    new_profile_emp_legal_name
                    new_profile_emp_profile_name,
                    new_profile_emp_fein`,
      },
      "employer-pocs": {
        name: "POC",
        returnFields: ` id,
                POCFormData {
                  poc_emp_profile_name,
                  poc_emp_last_name,
                  poc_emp_first_name
                   `,
      },
      "agent-attorney": {
        name: "AgentProfile",
        returnFields: ` id,
        AgentProfileFormData {
            new_profile_atty_agent_fein,
              new_profile_atty_agent_profile_name
              new_profile_atty_agent_dba
                   `,
      },
      "agent-attorney-individs": {
        name: "Agent",
        returnFields: ` id,
        AgentFormData {
            new_profile_individual_agent_last_name,
            new_profile_individual_agent_first_name,
            new_profile_individual_agent_profile_name,
            new_profile_individual_agent_job_title
                   `,
      },
      "foreign-labor": {
        name: "Recruiter",
        returnFields: ` id,
        RecruiterFormData {
            new_profile_fl_recr_last_name
            new_profile_fl_recr_first_name
            new_profile_fl_recr_middle_name
            new_profile_fl_recr_employer_name
            new_profile_fl_recr_city
            new_profile_fl_recr_state_id
            new_profile_fl_recr_zip
            new_profile_fl_recr_country_id
            new_profile_fl_recr_province
            new_profile_fl_recr_profile_name
            new_profile_fl_recr_reg_num_1
            new_profile_fl_recr_reg_num_country_1
            new_profile_fl_recr_reg_num_2
            new_profile_fl_recr_reg_num_country_2
            new_profile_fl_recr_reg_num_3
            new_profile_fl_recr_reg_num_country_3
                   `,
      },
      crop: {
        name: "Crop",
        returnFields: ` id,
        CropFormData {
          new_profile_crop_crop_id
          new_profile_crop_crop_work_state
          new_profile_crop_crop_agricultural_activity
          new_profile_crop_per
          new_profile_crop_wage_offer
          new_profile_crop_piece_rate_offer
          new_profile_crop_piece_rate_units
          new_profile_crop_profile_name
         `,
      },
      agriculture: {
        name: "Agriculture",
        returnFields: ` id,
        AgricultureFormData {
          new_profile_agriculture_emp_name
          new_profile_agriculture_worksite_address
          new_profile_agriculture_city
          new_profile_agriculture_state
          new_profile_agriculture_county{
            value,
            label
          }
          new_profile_agriculture_zip
          new_profile_agriculture_add_emp_info
          new_profile_agriculture_profile_name
         `,
      },
      "worker-housing": {
        name: "WorkerHousing",
        returnFields: `
        id,
        WorkerHousingFormData {
          new_profile_worker_housing_type_of_housing,
          new_profile_worker_housing_physical_location_address,
          new_profile_worker_housing_physical_location_city,
          new_profile_worker_housing_physical_location_state,
          new_profile_worker_housing_physical_location_county {
            label,
            value
          },
          new_profile_worker_housing_physical_location_zip_code,
          new_profile_worker_housing_additional_housing_information,
          new_profile_worker_housing_total_units,
          new_profile_worker_housing_total_occupancy,
          new_profile_worker_housing_applicable_housing_standards {
            label, value
          },
          new_profile_worker_housing_applicable_housing_standards_local,
          new_profile_worker_housing_applicable_housing_standards_swa,
          new_profile_worker_housing_applicable_housing_standards_other_state,
          new_profile_worker_housing_applicable_housing_standards_other,
          new_profile_worker_housing_applicable_housing_standards_federal,
          new_profile_worker_housing_applicable_housing_standards_other_text,
          new_profile_worker_housing_profile_name
        
                `,
      },
      "material-terms": {
        name: "MaterialTerms",
        returnFields: `
        id,
        MaterialTermsFormData {
          new_profile_material_terms_profile_name,
          new_profile_material_terms_section_number,
          new_profile_material_terms_summary,
          new_profile_material_terms_details,
                `,
      },
      "foreign-worker": {
        name: "ForeignWorker",
        returnFields: `
        id,
        ForeignWorkerFormData {
          new_profile_fw_profile_name,
          new_profile_fw_first,
          new_profile_fw_last,
          new_profile_fw_alien_reg_number,
          new_profile_fw_dob,
          new_profile_fw_birth_country,
          new_profile_fw_middle,
          new_profile_fw_address,
          new_profile_fw_address2,
          new_profile_fw_city,
          new_profile_fw_state,
          new_profile_fw_postal_code,
          new_profile_fw_country,
          new_profile_fw_province,
          new_profile_fw_class,
          new_profile_fw_citizen_country,
          new_group_fw_groups,
          new_profile_fw_education{
            appAEduTypeId,
            appAEduOther,
            appAEduMajors,
            appAEduInstName,
            appAEduCountryId,
            appAEduMonthYearAttained,
          },
          new_profile_fw_training_qualifications{
             appATrainingInstName,
             appATrainingName,
             appATrainingCert,
             appATrainingStartDate,
             appATrainingEndDate,
             appATrainingYearAwd,
          },
          new_profile_fw_skills{
            appASkillsInstName,
            appASkillsInstName,
            appASkillsCountryId,
            appASkillsStateId,
            fwTerritory,
            appASkillsSpecial,
          },
          new_profile_fw_work_experience{
            appAExpEmpName, 
            appAExpAddress1,
            appAExpAddress2,
            appAExpCity,
            appAExpPostalCode,
            appAExpCountryId,
            appAExpStateTerritory,
            appAExpProvince,
            appAExpJobTitle,
            appAExpStartDate,
            appAExpEndDate,
            appAExpFWPresent,
            appAExpWorkHour,
            appAExpJobDuties,
          }
                `,
      },
      "foreign-worker-group": {
        name: "ForeignWorkerGroup",
        returnFields: `
        id,
        ForeignWorkerGroupFormData {
          new_group_fw_group_name,
          new_group_fw_profiles,
          new_group_fw_num_profiles,
        `,
      },
    };

    let entity = listOfEntities[props.type];
    const query = `mutation  {
    add${entity.name}(${entity.name}Input:{${EInput}}, ${entity.name}FormData:{${EFormData}}
    ) {
    ${entity.returnFields}
  }

    }
    }
      `;
    const data = await GQLUtil.genericGQLQuery(query);
    if (data.data) {
      let newState = [...(data || [])];
      if (data.data.addEmployer) {
        newState.push(data.data.addEmployer);
      } else if (data.data.addAgentProfile) {
        newState.push(data.data.addAgentProfile);
      } else if (data.data.addAgent) {
        newState.push(data.data.addAgent);
      } else if (data.data.addPOC) {
        newState.push(data.data.addPOC);
      } else if (data.data.addRecruiter) {
        newState.push(data.data.addRecruiter);
      } else if (data.data.addCrop) {
        newState.push(data.data.addCrop);
      } else if (data.data.addAgriculture) {
        newState.push(data.data.addAgriculture);
      } else if (data.data.addWorkerHousing) {
        newState.push(data.data.addWorkerHousing);
      } else if (data.data.addMaterialTerms) {
        newState.push(data.data.addMaterialTerms);
      } else if (data.data.addForeignWorker) {
        newState.push(data.data.addForeignWorker);
      } else if (data.data.addForeignWorkerGroup) {
        newState.push(data.data.addForeignWorkerGroup);
      }
      let newEntityKey = entityKey + 1;
      setData(newState);
      setEntityKey(newEntityKey);
    }
  };

  const handleSave = (values) => {
    let formId = props.type;

    let userProfileInput = {
      group_id: userProfile.Group.id,
      user_id: userProfile.subject,
    };
    let payload = values;

    // add extra data to subs
    if (formId === "employer-pocs") {
      userProfileInput.employer_id = props.id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "agent-attorney-individs") {
      userProfileInput.agent_id = props.id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "crop") {
      delete userProfileInput.user_id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "agriculture") {
      delete userProfileInput.user_id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "material-terms") {
      delete userProfileInput.user_id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "worker-housing") {
      parseMultiSelectCheckboxForGQL(payload);
      delete userProfileInput.user_id;
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "foreign-worker") {
      delete userProfileInput.user_id;
      arrayNullFix(payload);
      handleGraphqlQuery(payload, userProfileInput);
    } else if (formId === "foreign-worker-group") {
      delete userProfileInput.user_id;
      handleGraphqlQuery(payload, userProfileInput);
    } else {
      handleGraphqlQuery(payload, userProfileInput);
    }

    closeModal();
  };

  // removes nulls from arrays
  const arrayNullFix = (payload) => {
    Object.keys(payload).forEach(function (key) {
      if (Array.isArray(payload[key])) {
        for (const x of payload[key]) {
          Object.keys(x).forEach(function (keys) {
            if (x[keys] === null) {
              delete x[keys];
            }
          });
        }
      }
    });
  }

    const uiSchema = ProfileUISchemaResolver(props.type); // where "type" === tableName
    const { view, title, navigateButton } = uiSchema;
    const { name, link } = uiSchema.linkBack;
    const { name: buttonName, style: buttonStyle } = uiSchema.button;
    const groupId = userProfile.Group.id;

    const renderTitle = (title) => (
      <h1 className="title main-title">{title}</h1>
    );

    const RefineSearchButton = () => {
      if (props.type === "foreign-worker") {
        return (
          <RefineSearch data={data}>
            <div className="refineSearch">
              <button className="refineButton" onClick={toggleModal}>
                Refine results <FaFilter />
              </button>
            </div>
          </RefineSearch>
        );
      } else {
        return null;
      }
    };
    const renderIndividualTitleForSubPage = () => {
      const { profileName, legalBusinessName, fein } = props;
      return (
        <div className="title">
          <p className="top-label">
            {legalBusinessName || "n/a"} <span className="divider">|</span>{" "}
            {fein || "n/a"}
          </p>
          <h1 className="main-label">{profileName || "n/a"}</h1>
        </div>
      );
    };

    const renderLinkback = (name, link) => (
      <div className="link-back-container">
        <Link className="usa-link link-back" to={link}>
          {name}
        </Link>
      </div>
    );

    let isSubaccount = false;
    if (userProfile.GroupRole === "Subaccount") {
      isSubaccount = true;
    }
    const columns = ProfileTableColumnResolver(
      props.type,
      isSubaccount,
      groupId
    );
    const noData = ProfileTableNoDataResolver(props.type);
    return (
      <div className={"profile-detail"}>
        {renderLinkback(name, link)}
        <div className="clearfix margin-top-3 grid-row">
          {view === "main"
            ? renderTitle(title)
            : renderIndividualTitleForSubPage()}
          {RefineSearchButton()}
          <Modal
            isOpen={isOpen}
            onRequestClose={toggleModal}
            contentLabel="Refine Search"
            className="refineSearchModal"
            overlayClassName="refineSearchOverlay"
          >
            <button
              onClick={toggleModal}
              className="caseFilterClose modal-exit-x"
              type="button"
            >
              <MdClose className="close-icon"></MdClose>
            </button>

            <div>
              <ProfilesFilter
                searchResults={searchResults}
                toggleModal={toggleModal}
                clearFilter={clearFilter}
                profile={props.type}
              />
            </div>
          </Modal>
          {userProfile.GroupRole === "Subaccount" ? (
            ""
          ) : (
            <NewEntityModal
              key={entityKey}
              modalIsOpen={isOpen}
              handleSubmit={handleSave}
              buttonType={"button"}
              formName={props.type}
              buttonName={buttonName}
              buttonStyle={buttonStyle}
              navigateButton={navigateButton}
              counties={counties}
              flexBasis={props.type === "foreign-worker-group" ? "60%" : "50%"}
              groupId={userProfile.Group.id}
            />
          )}
        </div>
        <ReactTable
          columns={columns}
          tableTheme="genericTheme"
          data={data || []}
          noDataComponent={noData}
          loading={loading}
          showPagination={data?.length > 0 ? true : false}
        ></ReactTable>
      </div>
    );
}

export default ProfilesDetail;
